// webpack compatible export of all icons
const ctx = (require as any).context('.', false, /^.*\.svg$/);
export default ctx.keys().reduce(
  (exp, key) => ({
    ...exp,
    [key.replace('./', '').replace('.svg', '')]: ctx(key).default,
  }),
  {},
);
